/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowADownIcon16Light } from './ArrowADownIcon16Light';
import { ArrowADownIcon16Regular } from './ArrowADownIcon16Regular';
import { ArrowADownIcon16Solid } from './ArrowADownIcon16Solid';
import { ArrowADownIcon20Light } from './ArrowADownIcon20Light';
import { ArrowADownIcon20Regular } from './ArrowADownIcon20Regular';
import { ArrowADownIcon20Solid } from './ArrowADownIcon20Solid';
import { ArrowADownIcon24Regular } from './ArrowADownIcon24Regular';
import { ArrowADownIcon24Solid } from './ArrowADownIcon24Solid';
import { ArrowADownIcon32Regular } from './ArrowADownIcon32Regular';
import { ArrowADownIcon64Regular } from './ArrowADownIcon64Regular';
var sizes = {
    16: {
        light: ArrowADownIcon16Light,
        regular: ArrowADownIcon16Regular,
        solid: ArrowADownIcon16Solid,
    },
    20: {
        light: ArrowADownIcon20Light,
        regular: ArrowADownIcon20Regular,
        solid: ArrowADownIcon20Solid,
    },
    24: {
        regular: ArrowADownIcon24Regular,
        solid: ArrowADownIcon24Solid,
    },
    32: {
        regular: ArrowADownIcon32Regular,
    },
    64: {
        regular: ArrowADownIcon64Regular,
    },
};
export var ArrowADownIcon = forwardRef('ArrowADownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
